export default [
  {name: 'Afeganistão', value: 'AFG', text: 'Afeganistão (AFG)'},
  {name: 'África do Sul', value: 'ZAF', text: 'África do Sul (ZAF)'},
  {name: 'Albânia', value: 'ALB', text: 'Albânia (ALB)'},
  {name: 'Alemanha', value: 'DEU', text: 'Alemanha (DEU)'},
  {name: 'Andorra', value: 'AND', text: 'Andorra (AND)'},
  {name: 'Angola', value: 'AGO', text: 'Angola (AGO)'},
  {name: 'Anguila', value: 'AIA', text: 'Anguila (AIA)'},
  {name: 'Antártica', value: 'ATA', text: 'Antártica (ATA)'},
  {name: 'Antiga e Barbuda', value: 'ATG', text: 'Antiga e Barbuda (ATG)'},
  {name: 'Arábia Saudita', value: 'SAU', text: 'Arábia Saudita (SAU)'},
  {name: 'Argélia', value: 'DZA', text: 'Argélia (DZA)'},
  {name: 'Argentina', value: 'ARG', text: 'Argentina (ARG)'},
  {name: 'Armênia', value: 'ARM', text: 'Armênia (ARM)'},
  {name: 'Aruba', value: 'ABW', text: 'Aruba (ABW)'},
  {name: 'Austrália', value: 'AUS', text: 'Austrália (AUS)'},
  {name: 'Áustria', value: 'AUT', text: 'Áustria (AUT)'},
  {name: 'Azerbaijão', value: 'AZE', text: 'Azerbaijão (AZE)'},
  {name: 'Bahamas', value: 'BHS', text: 'Bahamas (BHS)'},
  {name: 'Bangladesh', value: 'BGD', text: 'Bangladesh (BGD)'},
  {name: 'Barbados', value: 'BRB', text: 'Barbados (BRB)'},
  {name: 'Barém', value: 'BHR', text: 'Barém (BHR)'},
  {name: 'Bélgica', value: 'BEL', text: 'Bélgica (BEL)'},
  {name: 'Belize', value: 'BLZ', text: 'Belize (BLZ)'},
  {name: 'Benim', value: 'BEN', text: 'Benim (BEN)'},
  {name: 'Bielorrússia', value: 'BLR', text: 'Bielorrússia (BLR)'},
  {name: 'Bermudas', value: 'BMU', text: 'Bermudas (BMU)'},
  {name: 'Bolívia', value: 'BOL', text: 'Bolívia (BOL)'},
  {name: 'Bósnia e Herzegovina', value: 'BIH', text: 'Bósnia e Herzegovina (BIH)'},
  {name: 'Botsuana', value: 'BWA', text: 'Botsuana (BWA)'},
  {name: 'Brasil', value: 'BRA', text: 'Brasil (BRA)'},
  {name: 'Brunei', value: 'BRN', text: 'Brunei (BRN)'},
  {name: 'Bulgária', value: 'BGR', text: 'Bulgária (BGR)'},
  {name: 'Burquina Faso', value: 'BFA', text: 'Burquina Faso (BFA)'},
  {name: 'Burúndi', value: 'BDI', text: 'Burúndi (BDI)'},
  {name: 'Butão', value: 'BTN', text: 'Butão (BTN)'},
  {name: 'Cabo Verde', value: 'CPV', text: 'Cabo Verde (CPV)'},
  {name: 'Camarões', value: 'CMR', text: 'Camarões (CMR)'},
  {name: 'Camboja', value: 'KHM', text: 'Camboja (KHM)'},
  {name: 'Canadá', value: 'CAN', text: 'Canadá (CAN)'},
  {name: 'Catar', value: 'QAT', text: 'Catar (QAT)'},
  {name: 'Cazaquistão', value: 'KAZ', text: 'Cazaquistão (KAZ)'},
  {name: 'Chade', value: 'TCD', text: 'Chade (TCD)'},
  {name: 'Chile', value: 'CHL', text: 'Chile (CHL)'},
  {name: 'China', value: 'CHN', text: 'China (CHN)'},
  {name: 'Chipre', value: 'CYP', text: 'Chipre (CYP)'},
  {name: 'Vaticano', value: 'VAT', text: 'Vaticano (VAT)'},
  {name: 'Singapura', value: 'SGP', text: 'Singapura (SGP)'},
  {name: 'Colômbia', value: 'COL', text: 'Colômbia (COL)'},
  {name: 'Comores', value: 'COM', text: 'Comores (COM)'},
  {name: 'Congo-Brazavile', value: 'COG', text: 'Congo-Brazavile (COG)'},
  {name: 'Coreia do Norte', value: 'PRK', text: 'Coreia do Norte (PRK)'},
  {name: 'Coreia do Sul', value: 'KOR', text: 'Coreia do Sul (KOR)'},
  {name: 'Costa do Marfim', value: 'CIV', text: 'Costa do Marfim (CIV)'},
  {name: 'Costa Rica', value: 'CRI', text: 'Costa Rica (CRI)'},
  {name: 'Croácia', value: 'HRV', text: 'Croácia (HRV)'},
  {name: 'Cuba', value: 'CUB', text: 'Cuba (CUB)'},
  {name: 'Curaçao', value: 'CUW', text: 'Curaçao (CUW)'},
  {name: 'Dinamarca', value: 'DNK', text: 'Dinamarca (DNK)'},
  {name: 'Djibouti', value: 'DJI', text: 'Djibouti (DJI)'},
  {name: 'Dominica', value: 'DMA', text: 'Dominica (DMA)'},
  {name: 'Egito', value: 'EGY', text: 'Egito (EGY)'},
  {name: 'El Salvador', value: 'SLV', text: 'El Salvador (SLV)'},
  {name: 'Emirados Árabes Unidos', value: 'ARE', text: 'Emirados Árabes Unidos (ARE)'},
  {name: 'Equador', value: 'ECU', text: 'Equador (ECU)'},
  {name: 'Eritreia', value: 'ERI', text: 'Eritreia (ERI)'},
  {name: 'Eslováquia', value: 'SVK', text: 'Eslováquia (SVK)'},
  {name: 'Eslovênia', value: 'SVN', text: 'Eslovênia (SVN)'},
  {name: 'Espanha', value: 'ESP', text: 'Espanha (ESP)'},
  {name: 'Estado da Palestina', value: 'PSE', text: 'Estado da Palestina (PSE)'},
  {name: 'Estados Unidos', value: 'USA', text: 'Estados Unidos (USA)'},
  {name: 'Estônia', value: 'EST', text: 'Estônia (EST)'},
  {name: 'Eswatini', value: 'SWZ', text: 'Eswatini (SWZ)'},
  {name: 'Etiópia', value: 'ETH', text: 'Etiópia (ETH)'},
  {name: 'Fiji', value: 'FJI', text: 'Fiji (FJI)'},
  {name: 'Filipinas', value: 'PHL', text: 'Filipinas (PHL)'},
  {name: 'Finlândia', value: 'FIN', text: 'Finlândia (FIN)'},
  {name: 'França', value: 'FRA', text: 'França (FRA)'},
  {name: 'Gabão', value: 'GAB', text: 'Gabão (GAB)'},
  {name: 'Gâmbia', value: 'GMB', text: 'Gâmbia (GMB)'},
  {name: 'Gana', value: 'GHA', text: 'Gana (GHA)'},
  {name: 'Geórgia', value: 'GEO', text: 'Geórgia (GEO)'},
  {name: 'Geórgia do Sul e as Ilhas Sandwich do Sul', value: 'SGS', text: 'Geórgia do Sul e as Ilhas Sandwich do Sul (SGS)'},
  {name: 'Gibraltar', value: 'GIB', text: 'Gibraltar (GIB)'},
  {name: 'Granada', value: 'GRD', text: 'Granada (GRD)'},
  {name: 'Grécia', value: 'GRC', text: 'Grécia (GRC)'},
  {name: 'Guadalupe', value: 'GLP', text: 'Guadalupe (GLP)'},
  {name: 'Groenlândia', value: 'GRL', text: 'Groenlândia (GRL)'},
  {name: 'Guam', value: 'GUM', text: 'Guam (GUM)'},
  {name: 'Guatemala', value: 'GTM', text: 'Guatemala (GTM)'},
  {name: 'Guernsey', value: 'GGY', text: 'Guernsey (GGY)'},
  {name: 'Guiana', value: 'GUY', text: 'Guiana (GUY)'},
  {name: 'Guiana Francesa', value: 'GUF', text: 'Guiana Francesa (GUF)'},
  {name: 'Guiné', value: 'GIN', text: 'Guiné (GIN)'},
  {name: 'Guiné Equatorial', value: 'GNQ', text: 'Guiné Equatorial (GNQ)'},
  {name: 'Guiné-Bissau', value: 'GNB', text: 'Guiné-Bissau (GNB)'},
  {name: 'Haiti', value: 'HTI', text: 'Haiti (HTI)'},
  {name: 'Honduras', value: 'HND', text: 'Honduras (HND)'},
  {name: 'Hong Kong', value: 'HKG', text: 'Hong Kong (HKG)'},
  {name: 'Hungria', value: 'HUN', text: 'Hungria (HUN)'},
  {name: 'Iêmen', value: 'YEM', text: 'Iêmen (YEM)'},
  {name: 'Ilha Bouvet', value: 'BVT', text: 'Ilha Bouvet (BVT)'},
  {name: 'Ilha da Reunião', value: 'REU', text: 'Ilha da Reunião (REU)'},
  {name: 'Ilha de Man', value: 'IMN', text: 'Ilha de Man (IMN)'},
  {name: 'Ilha de Natal', value: 'CXR', text: 'Ilha de Natal (CXR)'},
  {name: 'Ilha Norfolk', value: 'NFK', text: 'Ilha Norfolk (NFK)'},
  {name: 'Ilhas Åland', value: 'ALA', text: 'Ilhas Åland (ALA)'},
  {name: 'Ilhas Cayman', value: 'CYM', text: 'Ilhas Cayman (CYM)'},
  {name: 'Ilhas Cocos', value: 'CCK', text: 'Ilhas Cocos (CCK)'},
  {name: 'Ilhas Cook', value: 'COK', text: 'Ilhas Cook (COK)'},
  {name: 'Ilhas Faroe', value: 'FRO', text: 'Ilhas Faroe (FRO)'},
  {name: 'Ilhas Malvinas', value: 'FLK', text: 'Ilhas Malvinas (FLK)'},
  {name: 'Ilhas Marianas do Norte', value: 'MNP', text: 'Ilhas Marianas do Norte (MNP)'},
  {name: 'Ilhas Marshall', value: 'MHL', text: 'Ilhas Marshall (MHL)'},
  {name: 'Ilhas Maurício', value: 'MUS', text: 'Ilhas Maurício (MUS)'},
  {name: 'Ilhas Menores Distantes dos Estados Unidos', value: 'UMI', text: 'Ilhas Menores Distantes dos Estados Unidos (UMI)'},
  {name: 'Ilhas Pitcairn', value: 'PCN', text: 'Ilhas Pitcairn (PCN)'},
  {name: 'Ilhas Salomão', value: 'SLB', text: 'Ilhas Salomão (SLB)'},
  {name: 'Ilhas Turcas e Caicos', value: 'TCA', text: 'Ilhas Turcas e Caicos (TCA)'},
  {name: 'Ilhas Virgens Reino Unido', value: 'VGB', text: 'Ilhas Virgens Reino Unido (VGB)'},
  {name: 'Ilhas Virgens dos Estados Unidos', value: 'VIR', text: 'Ilhas Virgens dos Estados Unidos (VIR)'},
  {name: 'Índia', value: 'IND', text: 'Índia (IND)'},
  {name: 'Indonésia', value: 'IDN', text: 'Indonésia (IDN)'},
  {name: 'Irã', value: 'IRN', text: 'Irã (IRN)'},
  {name: 'Iraque', value: 'IRQ', text: 'Iraque (IRQ)'},
  {name: 'Irlanda', value: 'IRL', text: 'Irlanda (IRL)'},
  {name: 'Islândia', value: 'ISL', text: 'Islândia (ISL)'},
  {name: 'Israel', value: 'ISR', text: 'Israel (ISR)'},
  {name: 'Itália', value: 'ITA', text: 'Itália (ITA)'},
  {name: 'Jamaica', value: 'JAM', text: 'Jamaica (JAM)'},
  {name: 'Japão', value: 'JPN', text: 'Japão (JPN)'},
  {name: 'Jersey', value: 'JEY', text: 'Jersey (JEY)'},
  {name: 'Jordânia', value: 'JOR', text: 'Jordânia (JOR)'},
  {name: 'Kosovo', value: 'XXK', text: 'Kosovo (XXK)'},
  {name: 'Kuwait', value: 'KWT', text: 'Kuwait (KWT)'},
  {name: 'Laos', value: 'LAO', text: 'Laos (LAO)'},
  {name: 'Lesoto', value: 'LSO', text: 'Lesoto (LSO)'},
  {name: 'Letônia', value: 'LVA', text: 'Letônia (LVA)'},
  {name: 'Líbano', value: 'LBN', text: 'Líbano (LBN)'},
  {name: 'Libéria', value: 'LBR', text: 'Libéria (LBR)'},
  {name: 'Líbia', value: 'LBY', text: 'Líbia (LBY)'},
  {name: 'Liechtenstein', value: 'LIE', text: 'Liechtenstein (LIE)'},
  {name: 'Lituânia', value: 'LTU', text: 'Lituânia (LTU)'},
  {name: 'Luxemburgo', value: 'LUX', text: 'Luxemburgo (LUX)'},
  {name: 'Macau', value: 'MAC', text: 'Macau (MAC)'},
  {name: 'Macedônia', value: 'MKD', text: 'Macedônia (MKD)'},
  {name: 'Madagáscar', value: 'MDG', text: 'Madagáscar (MDG)'},
  {name: 'Malásia', value: 'MYS', text: 'Malásia (MYS)'},
  {name: 'Maláui', value: 'MWI', text: 'Maláui (MWI)'},
  {name: 'Maldivas', value: 'MDV', text: 'Maldivas (MDV)'},
  {name: 'Mali', value: 'MLI', text: 'Mali (MLI)'},
  {name: 'Malta', value: 'MLT', text: 'Malta (MLT)'},
  {name: 'Marrocos', value: 'MAR', text: 'Marrocos (MAR)'},
  {name: 'Martinica', value: 'MTQ', text: 'Martinica (MTQ)'},
  {name: 'Mauritânia', value: 'MRT', text: 'Mauritânia (MRT)'},
  {name: 'Mayotte', value: 'MYT', text: 'Mayotte (MYT)'},
  {name: 'México', value: 'MEX', text: 'México (MEX)'},
  {name: 'Mianmar', value: 'MMR', text: 'Mianmar (MMR)'},
  {name: 'Micronésia', value: 'FSM', text: 'Micronésia (FSM)'},
  {name: 'Moçambique', value: 'MOZ', text: 'Moçambique (MOZ)'},
  {name: 'Moldávia', value: 'MDA', text: 'Moldávia (MDA)'},
  {name: 'Mônaco', value: 'MCO', text: 'Mônaco (MCO)'},
  {name: 'Mongólia', value: 'MNG', text: 'Mongólia (MNG)'},
  {name: 'Montenegro', value: 'MNE', text: 'Montenegro (MNE)'},
  {name: 'Montserrat', value: 'MSR', text: 'Montserrat (MSR)'},
  {name: 'Namíbia', value: 'NAM', text: 'Namíbia (NAM)'},
  {name: 'Nauru', value: 'NRU', text: 'Nauru (NRU)'},
  {name: 'Nepal', value: 'NPL', text: 'Nepal (NPL)'},
  {name: 'Nicarágua', value: 'NIC', text: 'Nicarágua (NIC)'},
  {name: 'Níger', value: 'NER', text: 'Níger (NER)'},
  {name: 'Nigéria', value: 'NGA', text: 'Nigéria (NGA)'},
  {name: 'Niue', value: 'NIU', text: 'Niue (NIU)'},
  {name: 'Noruega', value: 'NOR', text: 'Noruega (NOR)'},
  {name: 'Nova Caledônia', value: 'NCL', text: 'Nova Caledônia (NCL)'},
  {name: 'Nova Zelândia', value: 'NZL', text: 'Nova Zelândia (NZL)'},
  {name: 'Omã', value: 'OMN', text: 'Omã (OMN)'},
  {name: 'Ouvido e Ilhas McDonald', value: 'HMD', text: 'Ouvido e Ilhas McDonald (HMD)'},
  {name: 'Países Baixos', value: 'NLD', text: 'Países Baixos (NLD)'},
  {name: 'Países Baixos Caribenhos', value: 'BES', text: 'Países Baixos Caribenhos (BES)'},
  {name: 'Palau', value: 'PLW', text: 'Palau (PLW)'},
  {name: 'Panamá', value: 'PAN', text: 'Panamá (PAN)'},
  {name: 'Papua Nova Guiné', value: 'PNG', text: 'Papua Nova Guiné (PNG)'},
  {name: 'Paquistão', value: 'PAK', text: 'Paquistão (PAK)'},
  {name: 'Paraguai', value: 'PRY', text: 'Paraguai (PRY)'},
  {name: 'Peru', value: 'PER', text: 'Peru (PER)'},
  {name: 'Polinésia Francesa', value: 'PYF', text: 'Polinésia Francesa (PYF)'},
  {name: 'Polônia', value: 'POL', text: 'Polônia (POL)'},
  {name: 'Porto Rico', value: 'PRI', text: 'Porto Rico (PRI)'},
  {name: 'Portugal', value: 'PRT', text: 'Portugal (PRT)'},
  {name: 'Quênia', value: 'KEN', text: 'Quênia (KEN)'},
  {name: 'Quirguistão', value: 'KGZ', text: 'Quirguistão (KGZ)'},
  {name: 'Quiribáti', value: 'KIR', text: 'Quiribáti (KIR)'},
  {name: 'Reino Unido', value: 'GBR', text: 'Reino Unido (GBR)'},
  {name: 'República Centro-Africana', value: 'CAF', text: 'República Centro-Africana (CAF)'},
  {name: 'República Democrática do Congo', value: 'COD', text: 'República Democrática do Congo (COD)'},
  {name: 'República de San Marino', value: 'SMR', text: 'República de San Marino (SMR)'},
  {name: 'República Dominicana', value: 'DOM', text: 'República Dominicana (DOM)'},
  {name: 'República Tcheca', value: 'CZE', text: 'República Tcheca (CZE)'},
  {name: 'Romênia', value: 'ROU', text: 'Romênia (ROU)'},
  {name: 'Ruanda', value: 'RWA', text: 'Ruanda (RWA)'},
  {name: 'Rússia', value: 'RUS', text: 'Rússia (RUS)'},
  {name: 'Saara Ocidental', value: 'ESH', text: 'Saara Ocidental (ESH)'},
  {name: 'Samoa', value: 'WSM', text: 'Samoa (WSM)'},
  {name: 'Samoa Americana', value: 'ASM', text: 'Samoa Americana (ASM)'},
  {name: 'Santa Helena', value: 'SHN', text: 'Santa Helena, Ascensão e Tristão da Cunha (SHN)'},
  {name: 'Santa Lúcia', value: 'LCA', text: 'Santa Lúcia (LCA)'},
  {name: 'Santo Bartolomeu', value: 'BLM', text: 'Santo Bartolomeu (BLM)'},
  {name: 'São Cristóvão e Neves', value: 'KNA', text: 'São Cristóvão e Neves (KNA)'},
  {name: 'São Martinho', value: 'MAF', text: 'São Martinho (MAF)'},
  {name: 'São Pedro e Miquelon', value: 'SPM', text: 'São Pedro e Miquelon (SPM)'},
  {name: 'São Tomé e Príncipe', value: 'STP', text: 'São Tomé e Príncipe (STP)'},
  {name: 'São Vicente e Granadinas', value: 'VCT', text: 'São Vicente e Granadinas (VCT)'},
  {name: 'Senegal', value: 'SEN', text: 'Senegal (SEN)'},
  {name: 'Serra Leoa', value: 'SLE', text: 'Serra Leoa (SLE)'},
  {name: 'Sérvia', value: 'SRB', text: 'Sérvia (SRB)'},
  {name: 'Seychelles', value: 'SYC', text: 'Seychelles (SYC)'},
  {name: 'Sint Maarten', value: 'SXM', text: 'Sint Maarten (SXM)'},
  {name: 'Síria', value: 'SYR', text: 'Síria (SYR)'},
  {name: 'Somália', value: 'SOM', text: 'Somália (SOM)'},
  {name: 'Sri Lanka', value: 'LKA', text: 'Sri Lanka (LKA)'},
  {name: 'Sudão', value: 'SDN', text: 'Sudão (SDN)'},
  {name: 'Sudão do Sul', value: 'SSD', text: 'Sudão do Sul (SSD)'},
  {name: 'Suécia', value: 'SWE', text: 'Suécia (SWE)'},
  {name: 'Suíça', value: 'CHE', text: 'Suíça (CHE)'},
  {name: 'Suriname', value: 'SUR', text: 'Suriname (SUR)'},
  {name: 'Svalbard e Jan Mayen', value: 'SJM', text: 'Svalbard e Jan Mayen (SJM)'},
  {name: 'Tailândia', value: 'THA', text: 'Tailândia (THA)'},
  {name: 'Taiwan', value: 'TWN', text: 'Taiwan (TWN)'},
  {name: 'Tajiquistão', value: 'TJK', text: 'Tajiquistão (TJK)'},
  {name: 'Tanzânia', value: 'TZA', text: 'Tanzânia (TZA)'},
  {name: 'Território Britânico do Oceano Índico', value: 'IOT', text: 'Território Britânico do Oceano Índico (IOT)'},
  {name: 'Territórios Franceses do Sul e Antártico', value: 'ATF', text: 'Territórios Franceses do Sul e Antártico (ATF)'},
  {name: 'Timor-Leste', value: 'TLS', text: 'Timor-Leste (TLS)'},
  {name: 'Togo', value: 'TGO', text: 'Togo (TGO)'},
  {name: 'Tokelau', value: 'TKL', text: 'Tokelau (TKL)'},
  {name: 'Tonga', value: 'TON', text: 'Tonga (TON)'},
  {name: 'Trindade e Tobago', value: 'TTO', text: 'Trindade e Tobago (TTO)'},
  {name: 'Tunísia', value: 'TUN', text: 'Tunísia (TUN)'},
  {name: 'Turcomenistão', value: 'TKM', text: 'Turcomenistão (TKM)'},
  {name: 'Turquia', value: 'TUR', text: 'Turquia (TUR)'},
  {name: 'Tuvalu', value: 'TUV', text: 'Tuvalu (TUV)'},
  {name: 'Ucrânia', value: 'UKR', text: 'Ucrânia (UKR)'},
  {name: 'Uganda', value: 'UGA', text: 'Uganda (UGA)'},
  {name: 'Uruguai', value: 'URY', text: 'Uruguai (URY)'},
  {name: 'Uzbequistão', value: 'UZB', text: 'Uzbequistão (UZB)'},
  {name: 'Vanuatu', value: 'VUT', text: 'Vanuatu (VUT)'},
  {name: 'Venezuela', value: 'VEN', text: 'Venezuela (VEN)'},
  {name: 'Vietnã', value: 'VNM', text: 'Vietnã (VNM)'},
  {name: 'Wallis e Futuna', value: 'WLF', text: 'Wallis e Futuna (WLF)'},
  {name: 'Zâmbia', value: 'ZMB', text: 'Zâmbia (ZMB)'},
  {name: 'Zimbábue', value: 'ZWE', text: 'Zimbábue (ZWE)'}
]



// WEBPACK FOOTER //
// ./src/shared/CountriesWithCode.js